import { DataGrid, DataGridProps } from "@mui/x-data-grid"
import { GENERIC_DATA_GRID_ID } from "./GenericDataGrid"
import { useDataGridFilter } from "./hooks/useDataGridFilter"
import { TSortFilter } from "./hooks/useDataGridFilterState"

/**
 * Material-ui data-grid using url filter mechanism
 * @deprecated This component naming doesn't make sense, use "GenericDataGrid"
 */
export const FilterDataGrid = ({ pathname, defaultValue, ...props }: Props) => {

    const { 
        handleSortModelChange, 
        sortModel, 
        rowPerPage, 
        handlePageSizeChange,
        handlePageChange, 
        filter
    } = useDataGridFilter(props.id || GENERIC_DATA_GRID_ID, true, defaultValue)
    
    return (
        <DataGrid
            autoHeight
            sortingMode="client"
            paginationMode="client"
            filterMode="client"
            rowsPerPageOptions={rowPerPage}
            {...props}
            page={filter?.page}
            pageSize={filter?.pageSize || 20}
            sortModel={sortModel}
            onPageChange={handlePageChange}
            onPageSizeChange={handlePageSizeChange}
            onSortModelChange={handleSortModelChange}
        />
    )
}

type Props = DataGridProps & {
    /** Unique id of the datagrid */
    id?: string
    pathname: string,
    defaultValue?: TSortFilter
}
